var map = {
	"./AL.svg": "956b",
	"./CAMBRI.svg": "b73e",
	"./CH.svg": "b46a",
	"./EFTOT.svg": "7c2c",
	"./EITLS.svg": "6dee",
	"./ES.svg": "dfc1",
	"./FR.svg": "7654",
	"./HOL.svg": "137a",
	"./IN.svg": "c7fb",
	"./IT.svg": "318f",
	"./PO.svg": "3964",
	"./QUECHU.svg": "02d5",
	"./check.svg": "6b89",
	"./check_on.svg": "beea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ba2";